import React, { memo } from 'react';
import { TagIcon } from 'lucide-react';
interface AnnouncementBarProps {
  desktopOnly?: boolean;
}
const announcement = 'Save up to 25% on daily wellness essentials · Free delivery on qualifying orders · Shop offers today';
export const AnnouncementBar = memo(function AnnouncementBar({
  desktopOnly = true
}: AnnouncementBarProps) {
  const repeatedAnnouncement = Array.from({
    length: 4
  }, (_, index) => <span key={index} className="flex shrink-0 items-center gap-2 pr-12" data-id="element-2052" data-mp="rdbe54x6sy4t">
      <TagIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-2053" data-mp="vd20mwfoks3j" />
      <span data-id="element-2054" data-mp="vfo8kx6hh9ma">{announcement}</span>
    </span>);
  return <aside className={`overflow-hidden border-y border-promo-border bg-promo-light text-[#A95712] ${desktopOnly ? 'hidden md:block' : 'md:hidden'}`} aria-label="Current promotion" data-id="element-2055" data-mp="10bn4d5u55twq">
      <a href="/offers" className="block h-9 overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-promo" data-id="element-2056" data-mp="2bsmrln1mtijw">
        <span className="sr-only" data-id="element-2057" data-mp="2gsrbzo5nuxfe">{announcement}</span>
        <div className="announcement-ticker flex h-full w-max items-center text-xs font-semibold" aria-hidden="true" data-id="element-2058" data-mp="109ur206808u0">
          {repeatedAnnouncement}
        </div>
      </a>
    </aside>;
});